export default {
  header: 'Pinned apps',
  subheader: 'Drag the apps you want in the navigation bar into the list of pinned apps and arrange them in the order in which they appear there.',
  pinnedApps: 'Pinned apps',
  pinnedAppsEmpty: 'Drag apps here to pin them.',
  availableApps: 'Available apps',
  availableAppsEmpty: 'All available apps are pinned. Drag an app here to unpin it.',
};
